import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  tokenCallbackEvent = new EventEmitter<any>();
  usernameCallbackEvent = new EventEmitter<any>();
  private token?: string;
  private sessionKey?: string;
  private jwt: any;

  public getJWTObject() {
    return this.jwt;
  }

  private parseJwt(token: string) {
    if (token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      return JSON.parse(window.atob(base64));
    }
    return {};
  }

  getJWT() {
    return this.token;
  }

  setJWT(jwt: string) {
    this.token = jwt;
    this.jwt = this.parseJwt(jwt);
  }

  getSessionKey() {
    return this.sessionKey;
  }

  setSessionKey(key: string) {
    this.sessionKey = key;
  }

  getUserName(): string {
    if (!this.jwt) {
      throw new Error('User is not logged in, cannot get user name!');
    }
    return this.jwt['name'];
  }

  getEmail(): string {
    if (!this.jwt) {
      throw new Error('User is not logged in, cannot get user email!');
    }
    return this.jwt['email'];
  }

  isOwnItem(createdBy: string | undefined): boolean {
    if (!createdBy) {
      return false;
    }

    const transformedCreatedBy = createdBy.toLowerCase().trim();
    const transformedUsername = this.getUserName().toLowerCase().trim();
    const transformedEmail = this.getEmail().toLowerCase().trim();

    return (
      transformedCreatedBy === transformedUsername ||
      transformedEmail.startsWith(transformedCreatedBy)
    );
  }

  getUserGroups(): string[] {
    if (!this.jwt) {
      throw new Error('User is not logged in, cannot get user groups!');
    }

    return this.jwt['cr_roles'];
  }
}
